import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';

import { ConnectionLayoutComponent } from './component/connection/connection-layout/connection-layout.component';
import { ConnectionComponent } from './component/connection/connection/connection.component';
import { ForgetPasswordComponent } from './component/connection/forget-password/forget-password.component';
import { SupervisorComponent } from './component/supervisor-tab/supervisor.component';
import { AccountGuard } from './services/account-guard.service';
import { AuthGuard } from './services/auth-guard.service';
import { LoginGuard } from './services/login-guard.service';

import { PasswordChangeComponent } from './component/administration-tab/users-sub-tab/passwordchange/passwordchange.component';
import { AroundComponent } from './component/around/around.component';
import { MyAccountComponent } from './component/avatar-menu/my-account/my-account.component';
import { DashboardComponent } from './component/dashboard-tab/dashboard.component';
import { GlobalLayoutComponent } from './component/global-layout/global-layout.component';
import { MapTabComponent } from './component/map-tab/map-tab.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: GlobalLayoutComponent,
    canActivate: [
      (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        inject(AuthGuard).canActivate(next, state),
    ],
    canActivateChild: [
      (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        inject(AuthGuard).canActivateChild(next, state),
    ],
    children: [
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'map', component: MapTabComponent },
      {
        path: 'park',
        loadChildren: () => import('./component/devices/device.routing.module').then(d => d.DeviceRoutes),
      },
      {
        path: 'history',
        loadChildren: () =>
          import('./component/history/history-routing.module').then(h => h.HistoryRoutes),
      },
      {
        path: 'statistics',
        loadChildren: () =>
          import('./component/statistics-tab/statistics.routing.module').then(r => r.ReportRoutes),
      },
      {
        path: 'maintenances',
        loadChildren: () =>
          import('./component/maintenances-tab/maintenances.routing.module').then(
            m => m.MaintenanceRoutes
          ),
      },
      {
        path: 'management',
        loadChildren: () =>
          import('./component/management-tab/management-tab.routing.module').then(
            m => m.ManagementTabRoutes
          ),
      },
      {
        path: 'mobility',
        loadChildren: () =>
          import('./component/mobility-tab/mobility-tab.routing.module').then(
            m => m.MobilityTabRoutes
          ),
      },
      {
        path: 'resources',
        loadChildren: () =>
          import('./component/resources-tab/resources-routing.module').then(u => u.ResourcesRoutes),
      },
      {
        path: 'administration',
        loadChildren: () =>
          import('./component/administration-tab/admin-routing.module').then(u => u.AdminRoutes),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./component/notifications-tab/notifications.routing.module').then(
            u => u.NotificationsTabsRoutes
          ),
      },
      { path: 'around', component: AroundComponent },
      { path: 'my-account', component: MyAccountComponent },
      { path: 'devices', redirectTo: '/park' },
      { path: 'drivers', redirectTo: '/mobility/drivers' },
      { path: 'pois', redirectTo: '/management/landmarks' },
      { path: 'missions', redirectTo: '/mobility/missions' },
      { path: 'alarms', redirectTo: '/management/alarms' },
    ],
  },
  {
    path: 'change-password',
    component: PasswordChangeComponent,
    canMatch: [(state: RouterStateSnapshot) => inject(AuthGuard).isForceChangePassword()],
  },
  {
    path: 'login',
    component: ConnectionLayoutComponent,
    canMatch: [(state: RouterStateSnapshot) => inject(LoginGuard).canActivate(state)],
    children: [
      {
        path: '',
        component: ConnectionComponent,
      },
    ],
  },
  {
    path: 'supervisor',
    canActivate: [() => inject(AccountGuard).canActivate()],
    component: SupervisorComponent,
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
    canMatch: [(state: RouterStateSnapshot) => inject(LoginGuard).canActivate(state)],
  },
];
